import React from "react";
import { AEMModalContainer } from "components/AEMModalContainer";
import styled from "styled-components/macro";

interface Props {
	closeModal: any;
	coHostNameList: Array<string>;
}

export const ViewCoHostModal = ({ closeModal, coHostNameList }: Props) => {
	return (
		<AEMModalContainer closeModal={closeModal}>
			<Container>
				<Title>Co-hosts</Title>
				<NameContainer>
					{coHostNameList.map((coHost) => {
						return <div>{coHost}</div>;
					})}
				</NameContainer>
			</Container>
		</AEMModalContainer>
	);
};
const Container = styled.div`
	position: relative;
	width: 600px;
	padding: 24px 48px;
	box-sizing: border-box;
	width: 570px;
	padding: 60px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 64px;
	@media (max-width: 719px) {
		height: 100vh;
		width: 100vw;
	}
`;

const NameContainer = styled.div`
	color: #002d70;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	display: flex;
	gap: 19px;
	flex-direction: column;
	padding: 64px 156px;
	@media (max-width: 500px) {
		padding: 64px 40px;
	}
`;

const Title = styled.div`
	color: #002d70;
	text-align: center;
	font-size: 28px;
	font-style: normal;
	font-weight: 400;
	line-height: 32px;
`;
